module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-LightOblique-7d8859906ea4fe0a7d7eca82ce7c6139.svg";